export default function stripHtml(html: string | undefined | null) {
  return html?.replace(/<[^>]*>/g, '') || '';
}